import React from 'react'
import styled, { css } from 'styled-components'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import Theme from 'components/common/Theme/Theme'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import { A } from 'components/common/Link/Link'
import PhoneLink from 'components/common/PhoneLink'
import { QuantityReduxForm } from 'components/common/Quantity/Quantity'
import { formatPrice } from 'helpers/utils'
import {
  CALL_STORE_FOR_PRICE_FIRST_TEXT,
  SELECT_STORE_FOR_SKU_PRICE_TEXT
} from 'constant'

const QuantityInput = ({ input, meta, ...props }) =>
  <TireQuantity { ...props } { ...input } { ...meta } />

QuantityInput.propTypes = {
  input: PropTypes.shape(),
  meta: PropTypes.shape()
}

const TireControl = ({
  title,
  formattedStorePhoneNumber,
  storePhoneNumber,
  hasMapPrice,
  mapPrice = '',
  mapPriceForSet = '',
  seePriceIncartMessage,
  quantityInputId,
  pricePerItem,
  price,
  model,
  quantity,
  mapShowPhoneNumber,
  showSelectLocationLinkInsteadOfPrice,
  handleSelectLocationLinkClick
}) =>
  <React.Fragment>
    { title && <Title data-at-tirecontrol-title>{ title }</Title> }
    <React.Fragment>
      {
        showSelectLocationLinkInsteadOfPrice ?
          <>
            {mapPrice && (
              <>
                <span data-at-tirecontrol-price-each>
                  <Price>{ formatPrice(mapPrice) }</Price>
                  /each
                </span>
                <br />
                <span data-at-tirecontrol-price-setof>
                  <Price small>{ formatPrice(mapPriceForSet) }</Price>
                  set of { quantity }
                </span>
                <br />
              </>
            )}
            <A
              data-at-tirecontrol-selectstore
              bolder
              prevent
              handler={ handleSelectLocationLinkClick }>
              {SELECT_STORE_FOR_SKU_PRICE_TEXT}
            </A>
          </> :
          pricePerItem === 0 ?
            <CallStore data-at-tirecontrol-callstore>
              { CALL_STORE_FOR_PRICE_FIRST_TEXT }
              <Media.Mobile>
                <StyledPhoneLink data-at-tirecontrol-phone number={ storePhoneNumber } />
              </Media.Mobile>
              <Media.Desktop>
                <Phone data-at-tirecontrol-phone>{ formattedStorePhoneNumber }</Phone>
              </Media.Desktop>
            </CallStore> :
            hasMapPrice ?
              <CallStore>
                { seePriceIncartMessage }
                { mapShowPhoneNumber &&
                  <React.Fragment>
                    <Media.Mobile>
                      <StyledPhoneLink data-at-tirecontrol-phone number={ storePhoneNumber } />
                    </Media.Mobile>
                    <Media.Desktop>
                      <Phone data-at-tirecontrol-phone>{ formattedStorePhoneNumber }</Phone>
                    </Media.Desktop>
                  </React.Fragment>
                }
              </CallStore> :
              <React.Fragment>
                <span data-at-tirecontrol-price-each>
                  <Price>{ formatPrice(pricePerItem) }</Price>
                  /each
                </span>
                <br />
                <span data-at-tirecontrol-price-setof>
                  <Price small>{ formatPrice(price) }</Price>
                  set of { quantity }
                </span>
              </React.Fragment>
      }
      <br />
    </React.Fragment>
    <QuantityWrapper>
      <fieldset>
        <Media.Mobile>
          <QuantityText>Quantity</QuantityText>
        </Media.Mobile>
        <Media.Desktop>
          <QuantityText>Qty</QuantityText>
        </Media.Desktop>
        <Field { ...model } id={ quantityInputId } component={ QuantityInput } />
      </fieldset>
    </QuantityWrapper>
  </React.Fragment>

TireControl.propTypes = {
  altTire: PropTypes.shape(),
  formattedStorePhoneNumber: PropTypes.string,
  handleSelectLocationLinkClick: PropTypes.func,
  hasMapPrice: PropTypes.bool,
  mapPrice: PropTypes.string,
  mapPriceForSet: PropTypes.string,
  mapShowPhoneNumber: PropTypes.bool,
  model: PropTypes.shape(),
  mspn: PropTypes.string,
  price: PropTypes.string,
  pricePerItem: PropTypes.number,
  quantity: PropTypes.number,
  quantityInputId: PropTypes.string,
  seePriceIncartMessage: PropTypes.string,
  showSelectLocationLinkInsteadOfPrice: PropTypes.bool,
  skuId: PropTypes.string,
  storePhoneNumber: PropTypes.string,
  tireSize: PropTypes.string,
  title: PropTypes.string,
  zeroPriceItemMessage: PropTypes.string
}

export default TireControl

const Title = styled.div`
  line-height: 19px;
  color: ${Theme.colors.sub_grey};
  text-transform: uppercase;
  ${Mixin.font.GothamBold(14)}
`

const Price = styled.span`
  margin-right: 10px;
  line-height: 38px;
  color: ${Theme.colors.sub_grey};
  ${Mixin.font.GothamBold(28)}
  ${props => props.small && css`
    margin-right: 5px;
    line-height: 22px;
    color: ${Theme.colors.semidark_grey};
    ${Mixin.font.GothamBold(14)}
  `}
`

const TireQuantity = styled(QuantityReduxForm)`
  margin: 23px 0 30px;
`

const QuantityWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  ${Media.mobile`
    justify-content: space-between;
  `}
`

const QuantityText = styled.legend`
  float: left;
  margin: 23px 15px 30px 0;
  line-height: 40px;
  color: ${Theme.colors.dark_grey};
  ${Mixin.font.GothamBook(14)}
  ${Media.mobile`
    margin-right: 60px;
  `}
`

const StyledPhoneLink = styled(PhoneLink)`
  display: block;
  font-weight: 600;
  line-height: 22px;
`

const CallStore = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
`

const Phone = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
`
